import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CommonExplainModule } from '../../common-explain/common-explain.module';

@Component({
  selector: 'app-modal-topic-deleted',
  imports: [TranslateModule, CommonExplainModule],
  templateUrl: './modal-topic-deleted.component.html',
  styleUrl: './modal-topic-deleted.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class ModalTopicDeletedComponent {
  @Input() title!: string;
  @Input() content!: string;
  @Input() topicName?: string;

  constructor(private activeModal: NgbActiveModal) {}

  close() {
    this.activeModal.close();
  }

  dismissModal() {
    this.activeModal.dismiss();
  }
}
